import { Commands, Entity, EntityDefaultPropertiesManager, Events, eventsManager, Listener, math, SceneConstants, Wall } from "@rhinov/savane-js";
import { ActionState, ActionStateEnum, CreateWallState, IdleConstruction } from "..";

import { PlanManager } from "../../../../cocosPlan";

declare var cc: any;


export class IdleCreateState extends ActionState {

    createSeveralWalls: boolean;
    state: number = ActionStateEnum.idleCreate;
    entityEdition: Listener | null = null;

    constructor(createSeveralWalls?: boolean) {
        super();

        this.createSeveralWalls = createSeveralWalls === undefined ? false : createSeveralWalls;
        this.entityEdition = new Listener((data: any) => {
            var entity = data.userData.entity;
            if (entity !== null) {
                switch (entity.entityType) {
                    case SceneConstants.EntityType.Wall:
                        EntityDefaultPropertiesManager.getInstance().setCurrentToolParams(entity.thickness / 10);
                        break;
                }
            }
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.entityEdition);
    }

     fromVoiceRecognition(cursorPosition: math.vec3) {
        document.getElementById('gameCanvas')!.style.cursor = 'crosshair';
    }

    getAction(): number {
        if (this.createSeveralWalls) {
            return ActionStateEnum.idleMultipleCreates;
        } else {
            return ActionStateEnum.idleCreate;
        }
    }

    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        return new CreateWallState(cursorPosition, hoverEntities, this.createSeveralWalls);
    }

    actionDelete() {
        var planManager = PlanManager.getInstance();
        //FIXME This look like a skeleton !
        /*if (planManager.selectedEntities !== null &&
            planManager.selectedEntities.length > 0&&
            planManager.selectedEntities[0].isWallEntity()){
        }*/
        planManager.executeCommand(new Commands.DeleteWallCommand(planManager.selectedEntities as Wall[], planManager.selectedEntities));
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode == cc.KEY.escape) {
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction(undefined);
        }

        if (keyCode == cc.KEY.Delete || keyCode == cc.KEY.backspace) {
            this.actionDelete();
        }
        return null;
    }
    
    snapClick(): ActionState | null {
        if (this.createSeveralWalls) {
            return null;
        } else {
            return new IdleConstruction(undefined);
        }
    }

    dispose() {
        eventsManager.instance.removeListener(this.entityEdition!);
    }
}